export const VEHICLE_DESC_INFO =
  "예약 추가를 위해 차량번호 입력 후 [완료] 버튼을 눌러주세요. (*차량번호 예시: 서울 OO가 OOOO/ OO나 OOOO/ OOO가 OOOO)";

export const VEHICLE_NODATA_MSG =
  "검색 결과가 없습니다.\n차량 번호를 직접 입력해주세요";

export const VEHICLE_NODATA_DESC_INFO =
  "(*차량번호 예시: 서울 OO가OOOO/ \n OO나OOOO / OOO가OOOO)";
